import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initDeepLinkHandler } from "./lib/deepLinkHandler";
import { initManualScrollRestoration } from "./lib/scrollToTop";
import { initNativeAppUi } from "./lib/nativeAppUi";

console.log('🚀 [Main] Starting App Initialization...');

/**
 * Global Error Handler for Capacitor/Mobile Debugging
 * Catches unhandled promise rejections and exceptions to show them on screen
 */
window.addEventListener("unhandledrejection", (event) => {
  console.error("🔥 Unhandled Rejection:", event.reason);
  // Optional: Alert the user if debugging is critical
  // alert("Async Error: " + (event.reason?.message || JSON.stringify(event.reason)));
});

window.addEventListener("error", (event) => {
  console.error("🔥 Global Error:", event.error);
  // alert("Global Error: " + (event.error?.message || event.message));
});

try {
  // Initialize immediately before React render
  initManualScrollRestoration();
  initNativeAppUi();
  try {
     initDeepLinkHandler();
     console.log('🚀 [Main] Deep Link Handler Initialized');
  } catch (err) {
      console.error('⚠️ [Main] DeepLink Init Failed (Non-Critical)', err);
  }

  const container = document.getElementById("root");
  if (!container) {
    console.error('❌ [Main] Root element not found!');
  } else {
    console.log('🚀 [Main] Found Root Element, Mounting React...');
    const root = createRoot(container);
    root.render(<App />);
    console.log('🚀 [Main] React Mount Called');
  }
} catch (e) {
  console.error('❌ [Main] Critical Initialization Error:', e);
}
